import type { components } from '@pba/types-openapi-client';

export enum GivingTypeEnum {
  CROWDFUNDING = 'crowdfunding',
  DONATION = 'donation',
  OFFERING = 'offering',
  TITHE = 'tithe',
}

const supportedGivingType: Record<components['schemas']['GivingTypeEnum'], number> = {
  [GivingTypeEnum.CROWDFUNDING]: 1,
  [GivingTypeEnum.DONATION]: 1,
  [GivingTypeEnum.OFFERING]: 1,
  [GivingTypeEnum.TITHE]: 1,
};

export type GivingType = keyof typeof supportedGivingType;
